var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"blurElement",staticClass:"blur-reveal-element"},_vm._l((_vm.words),function(word,index){return _c('span',{key:index,staticClass:"word",class:{ 'revealed': _vm.revealedWords.includes(index) }},[_vm._v(" "+_vm._s(word)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }